module.exports = __webpack_public_path__ + "img/tv.ff409c75.svg";